import { Component, OnDestroy, OnInit } from '@angular/core';
import { PublicationService } from '../../../services/publication.service';
import { Publication } from '../../../interfaces/publication';
import { WebSocketsService } from '../../../services/web-sockets.service';
import { RealtimeService } from '../../../services/realtime.service';
import { Subscription } from 'rxjs';


@Component({
	templateUrl: './realtime-audience.component.html',
	styleUrls: ['./realtime-audience.component.scss']
})

export class RealtimeComponent implements OnInit, OnDestroy {
	loading: boolean;
	showSocketToggle: boolean;

	private useDevSocket: boolean;

	// fps measurement start
	private lastRun = 0;
	private runningTime = 0;
	private fps_running = true;
	private fpsArr: number[];
	private avgFpsArr: number[];
	private fpsTimer: any;
	private fpsMeasureTime = 5;		// how long the fps will be collected to create an average
	private fpsReportTime = 20;		// interval for running the measurement and telling the realtime service
	private subscriptions = new Subscription();
	// fps measurement end

	constructor(
		protected realtimeService: RealtimeService,
		private publicationService: PublicationService,
		private webSocketsService: WebSocketsService) {

		this.useDevSocket = false;
		this.showSocketToggle = false;
		this.loading = true;
	}

	ngOnInit() {
		this.subscriptions.add(this.publicationService.getData().subscribe((publication: Publication) => {
			if (publication) {
				const baseUrl = publication.baseurl;
				if (baseUrl.search(/\.dev\./) > -1 || baseUrl.search(/^dev\./) > -1) {
					this.showSocketToggle = true;
					this.useDevSocket = true;
					this.updateSocket(this.useDevSocket);
				}
			}
		}));

		this.realtimeService.initialCallFinished.subscribe((cf) => {
			setTimeout(() => {
				this.loading = !cf;
			}, 500);
		});

		// fps measurement start
		this.fpsArr = new Array<number>();
		this.avgFpsArr = new Array<number>();
		this.fps_running = true;
		this.runningTime = 0;
		this.measureFPS();

		this.fpsTimer = setInterval(() => {
			this.fps_running = true;
			this.lastRun = this.runningTime = 0;
			this.measureFPS();
		}, 1000 * this.fpsReportTime);
		// fps measurement end
	}

	ngOnDestroy() {
		if (this.fpsTimer) {
			clearInterval(this.fpsTimer);
		}
		this.subscriptions.unsubscribe();
	}

	updateSocket(val: boolean) {
		this.webSocketsService.useDevelopment = val;
	}


	// fps measurement start
	private measureFPS(): void {
		if (this.lastRun === 0) {
			this.lastRun = performance.now();
			window.requestAnimationFrame(() => {
				this.measureFPS();
			});
			return;
		}
		const delta: number = (performance.now() - this.lastRun) / 1000;

		this.lastRun = performance.now();
		const fps: number = 1 / delta;

		this.fpsArr.push(fps);

		this.runningTime += delta;
		if (this.runningTime > this.fpsMeasureTime) {
			let avgFPS = this.getAverageFPS(this.fpsArr);

			// console.log( 'this.fpsArr.length = '  + this.fpsArr.length );
			// console.log( 'avgFPS before correction = '  + avgFPS );

			this.avgFpsArr.push(avgFPS);
			if (this.avgFpsArr.length > 10) {
				this.avgFpsArr.splice(0, 1);
			}

			avgFPS = this.getAverageFPS(this.avgFpsArr);
			// console.log( 'avgFPS after correction = '  + avgFPS );

			this.fps_running = false;

			// set value in realtime service
			this.realtimeService.measuredFPS = avgFPS;
			this.fpsArr = new Array<number>();
			this.runningTime = 0;
		}


		if (this.fps_running) {
			window.requestAnimationFrame(() => {
				this.measureFPS();
			});
		}
	}

	private getAverageFPS(arr: number[]): number {
		let sum = 0;
		for (let i = 0; i < arr.length; i++) {
			sum += arr[i];
		}
		const avgFPS = sum / arr.length;
		return avgFPS;
	}
	// fps measurement end
}
